import React, { useState, useEffect } from 'react';
import { analyticsAPI } from '../services/api';
import { format } from 'date-fns';

const Errors = () => {
  const [errors, setErrors] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, totalPages: 0 });
  const [loading, setLoading] = useState(true);
  const [selectedError, setSelectedError] = useState(null);

  useEffect(() => {
    loadErrors();
  }, [pagination.page]);

  const loadErrors = async () => {
    setLoading(true);
    try {
      const response = await analyticsAPI.getErrors({
        page: pagination.page,
        limit: pagination.limit
      });
      setErrors(response.data.data);
      setPagination(response.data.pagination);
    } catch (error) {
      console.error('Error loading errors:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('it-IT').format(value || 0);
  };

  if (loading) {
    return <div className="loading">Caricamento...</div>;
  }

  return (
    <div>
      <div className="header">
        <h1>Messaggi con Errori</h1>
      </div>

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Session ID</th>
              <th>Prodotto</th>
              <th>Interfaccia</th>
              <th>Tipo Messaggio</th>
              <th>Errore</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {errors.map((error) => (
              <tr key={error.message_id}>
                <td>{format(new Date(error.created_at), 'dd/MM/yyyy HH:mm')}</td>
                <td>
                  <code style={{ fontSize: '12px' }}>
                    {error.session_id.substring(0, 8)}...
                  </code>
                </td>
                <td>{error.product_name}</td>
                <td>
                  <span style={{
                    padding: '3px 8px',
                    borderRadius: '3px',
                    fontSize: '12px',
                    background: error.interface_type === 'web' ? '#e3f2fd' : '#f3e5f5',
                    color: error.interface_type === 'web' ? '#1976d2' : '#7b1fa2'
                  }}>
                    {error.interface_type}
                  </span>
                </td>
                <td>
                  <span style={{
                    padding: '3px 8px',
                    borderRadius: '3px',
                    fontSize: '12px',
                    background: error.message_type === 'user' ? '#e3f2fd' : '#f3e5f5',
                    color: error.message_type === 'user' ? '#1976d2' : '#7b1fa2'
                  }}>
                    {error.message_type}
                  </span>
                </td>
                <td>
                  <div style={{
                    maxWidth: '300px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    color: '#dc3545'
                  }}>
                    {error.error_message}
                  </div>
                </td>
                <td>
                  <button
                    className="btn btn-primary"
                    style={{ padding: '5px 10px', fontSize: '12px' }}
                    onClick={() => setSelectedError(error)}
                  >
                    Dettagli
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Paginazione */}
        <div className="pagination">
          <button
            onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
            disabled={pagination.page === 1}
          >
            Precedente
          </button>
          <span>
            Pagina {pagination.page} di {pagination.totalPages} ({formatNumber(pagination.total)} totali)
          </span>
          <button
            onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
            disabled={pagination.page === pagination.totalPages}
          >
            Successiva
          </button>
        </div>
      </div>

      {/* Modal dettagli errore */}
      {selectedError && (
        <div className="modal-overlay" onClick={() => setSelectedError(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px' }}>
            <h2>Dettagli Errore</h2>

            <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '5px', marginBottom: '20px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', fontSize: '14px' }}>
                <div><strong>Data:</strong> {format(new Date(selectedError.created_at), 'dd/MM/yyyy HH:mm:ss')}</div>
                <div><strong>Session ID:</strong> <code>{selectedError.session_id}</code></div>
                <div><strong>Prodotto:</strong> {selectedError.product_name}</div>
                <div><strong>Interfaccia:</strong> {selectedError.interface_type}</div>
                <div><strong>Tipo Messaggio:</strong> {selectedError.message_type}</div>
                <div><strong>Sequenza:</strong> {selectedError.message_sequence}</div>
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <h3 style={{ marginBottom: '10px' }}>Messaggio</h3>
              <div style={{
                padding: '15px',
                background: '#f8f9fa',
                borderRadius: '5px',
                whiteSpace: 'pre-wrap',
                maxHeight: '200px',
                overflowY: 'auto'
              }}>
                {selectedError.message_content}
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <h3 style={{ marginBottom: '10px' }}>Errore</h3>
              <div style={{
                padding: '15px',
                background: '#f8d7da',
                color: '#721c24',
                borderRadius: '5px',
                whiteSpace: 'pre-wrap',
                maxHeight: '200px',
                overflowY: 'auto'
              }}>
                {selectedError.error_message}
              </div>
            </div>

            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setSelectedError(null)}>
                Chiudi
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Errors;

